import styled from '@emotion/styled'

import { breakpoints, GridLeft, GridRight } from '../../utils/styles'

export const Left = styled(GridLeft)`
  display: flex;
  align-items: center;
`

export const Right = styled(GridRight)`
  display: flex;
  align-items: center;
  text-align: right;
  justify-content: flex-end;

  @media (max-width: ${breakpoints.s}px) {
    text-align: left;
    margin-top: 20px;
    justify-content: flex-start;
  }
`

export const Wrapper = styled.footer`
  padding: 100px 40px;
  font-size: 14px;
  font-family: 'SohneBreit';
  width: 100%;
  box-sizing: border-box;
  letter-spacing: 1px;

  @media (max-width: ${breakpoints.s}px) {
    padding: 40px 20px;
    box-sizing: border-box;
    font-size: 10px;
  }
`

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1400px;

  a {
    color: currentColor;
  }
`

export const Title = styled.h3`
  font-size: 2.4rem;
  margin: 15px 0;
  line-height: 1;
`
